import { ApiKeyFields } from "types";

export const sortingMapping: Partial<Record<ApiKeyFields, string>> = {
  [ApiKeyFields.title]: ApiKeyFields.title,
  [ApiKeyFields.status]: ApiKeyFields.status,
  [ApiKeyFields.schedulesAt]: ApiKeyFields.schedules_at,
  [ApiKeyFields.opUpc]: ApiKeyFields.op_upc,
  [ApiKeyFields.opStatus]: ApiKeyFields.op_status,
};
